export const EMAIL_SAVED = 'EMAIL_SAVED';

export const emailSaved = payload => dispatch =>
  dispatch({
    type: EMAIL_SAVED,
    payload,
  });
